import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const SystemMaintenance = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">System Maintenance</h1>
            <p className="service-description">
              Proactive system maintenance services to keep your IT infrastructure
              running smoothly and prevent costly downtime.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Maintenance Services</h2>

              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">📞</div>
                    <h3>On Call Troubleshooting</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="On Call Troubleshooting details">
                    <div className="popover-title">On Call Troubleshooting covers</div>
                    <ul className="popover-list">
                      <li>Immediate remote/phone support</li>
                      <li>OS login, boot, and application errors</li>
                      <li>Network and connectivity issues</li>
                      <li>Peripheral/device setup help</li>
                      <li>Email and client configuration fixes</li>
                      <li>Minor hardware issue triage</li>
                      <li>Guided quick resolutions</li>
                    </ul>
                  </div>
                  <p>First-line support to quickly diagnose and resolve issues without a visit.</p>
                </div>

                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">📅</div>
                    <h3>Annual Maintenance Services</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="Annual Maintenance Services details">
                    <div className="popover-title">Annual Maintenance includes</div>
                    <ul className="popover-list">
                      <li>Quarterly preventive maintenance visits</li>
                      <li>OS, patches, and firmware updates</li>
                      <li>Antivirus and endpoint protection upkeep</li>
                      <li>Backup checks and restore drills</li>
                      <li>Asset and warranty tracking</li>
                      <li>Health reports and recommendations</li>
                      <li>Defined SLAs and priority response</li>
                    </ul>
                  </div>
                  <p>Proactive care plan to keep systems stable, secure, and performant all year.</p>
                </div>

                <div className="feature-item">
                  <div className="feature-header popover-trigger">
                    <div className="feature-icon">🧭</div>
                    <h3>Managed Services</h3>
                  </div>
                  <div className="feature-popover" role="dialog" aria-label="Managed Services details">
                    <div className="popover-title">Managed Services offer</div>
                    <ul className="popover-list">
                      <li>24×7 monitoring and alerting</li>
                      <li>Patch, AV, and policy management</li>
                      <li>Remote management and automation</li>
                      <li>Incident, change, and capacity management</li>
                      <li>Monthly performance and compliance reports</li>
                      <li>vCIO reviews and roadmap planning</li>
                      <li>Guaranteed SLAs</li>
                    </ul>
                  </div>
                  <p>End‑to‑end management of your endpoints and servers with SLAs.</p>
                </div>
              </div>





              <div className="benefits-section">
                <h2>Maintenance Benefits</h2>
                <ul className="benefits-list">
                  <li>✓ Reduced system downtime and failures</li>
                  <li>✓ Extended hardware lifespan</li>
                  <li>✓ Improved system performance</li>
                  <li>✓ Lower total cost of ownership</li>
                  <li>✓ Scheduled maintenance windows</li>
                  <li>✓ Detailed maintenance reports</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Frequency:</span>
                  <span className="highlight-value">Monthly</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Downtime:</span>
                  <span className="highlight-value">Minimal</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Reports:</span>
                  <span className="highlight-value">Detailed</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Scheduling:</span>
                  <span className="highlight-value">Flexible</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default SystemMaintenance;
